/**
 * @generated SignedSource<<c97c5b258e6679cdc97139884146f943>>
 * @relayHash e08c660ac5bdc886bb33b567a945aed4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceViewsControllerQuery$variables = {
  spaceKey: string;
};
export type SpaceViewsControllerQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type SpaceViewsControllerQuery = {
  response: SpaceViewsControllerQuery$data;
  variables: SpaceViewsControllerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceViewsControllerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceViewsControllerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e08c660ac5bdc886bb33b567a945aed4",
    "id": "2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba",
    "metadata": {},
    "name": "SpaceViewsControllerQuery",
    "operationKind": "query",
    "text": "query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "d33ab2e8cd8e66319f41302e5bdaa679";

export default node;
